import { CountryOrganization } from "@/domain/Country/Country";
import React from "react";

export interface LocationsContextInterface {
  countriesByOrganization: CountryOrganization[];
}

const initialContext: LocationsContextInterface = {
  countriesByOrganization: [],
};

const LocationsContext = React.createContext(initialContext);

export default LocationsContext;
